import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { OrganizationService } from '../../shared/services/organization.service';

@Injectable()
export class SiteResolver implements Resolve<any> {
    constructor(private organizationService: OrganizationService) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.organizationService.getSite(route.params.id);
    }
}
